export const revenueInfo = {
  OriginalRevenue: [2, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  AfterTrading: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
  CustomerRevenue: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
}

export const MonthLabelData = [
  '1월',
  '2월',
  '3월',
  '4월',
  '5월',
  '6월',
  '7월',
  '8월',
  '9월',
  '10월',
  '11월',
  '12월',
]
